import {
  activateExperiment,
  isExperimentEnabled,
  trackEvent
} from 'views/assets/scripts/optimizely'

import {
  PRE_QUERY_SUGGEST_NAME,
  SEARCH_BOX_CATEGORY_CLICK,
  SEARCH_BOX_SUGGESTED_PRODUCT_CLICK,
  SEARCH_BOX_QUERY_PRODUCT_CLICK,
  SEARCH_BOX_QUERY_SUGGESTION_CLICK
} from 'shared/experiments/consts'

import {
  SELECTOR_DESKTOP_INPUT,
  SELECTOR_DUMMY_SEARCH_BOX,
  SELECTOR_MOBILE_SEARCH_ICON
} from 'views/containers/browser/SearchBoxContainer/consts'

export default () => {
  if (!isExperimentEnabled(PRE_QUERY_SUGGEST_NAME)) {
    return
  }

  const searchInputs = [
    document.querySelector(SELECTOR_DESKTOP_INPUT),
    document.querySelector(SELECTOR_MOBILE_SEARCH_ICON),
    document.querySelector(SELECTOR_DUMMY_SEARCH_BOX)
  ].filter(Boolean)

  const activate = () => {
    activateExperiment(PRE_QUERY_SUGGEST_NAME)

    searchInputs.forEach(input => {
      input.removeEventListener('click', activate)
    })
  }

  searchInputs.forEach(input => {
    input.addEventListener('click', activate)
  })

  const experimentContainers = document.querySelectorAll(
    '[data-experiment="search-box-pqsl"]'
  )

  experimentContainers.forEach(experimentContainer => {
    experimentContainer.addEventListener('click', event => {
      const { target } = event

      if (target.closest('[data-clientside-hook~="SearchBoxListItemLink"]')) {
        trackEvent(SEARCH_BOX_QUERY_PRODUCT_CLICK)
      }

      if (
        target.closest('[data-clientside-hook~="SearchBoxListSuggestLink"]')
      ) {
        trackEvent(SEARCH_BOX_QUERY_SUGGESTION_CLICK)
      }

      if (
        target.closest('[data-clientside-hook~="SearchBoxListItemLink_PQ"]')
      ) {
        trackEvent(SEARCH_BOX_SUGGESTED_PRODUCT_CLICK)
      }

      if (target.closest('[data-clientside-hook~="SearhcBoxCategoryLink"]')) {
        trackEvent(SEARCH_BOX_CATEGORY_CLICK)
      }
    })
  })
}
